import { useMemo } from "react";
import {
  useAssignAndGetEvaluationTask,
  useGetAssignedEvaluationTask,
  type EvaluationTask,
  type Question,
} from "@services/evaluationService";


/**
 * Hook to get and transform assigned evaluation task
 */
export function useAssignedEvaluationTask(enabled: boolean = true) {
  const { data, isLoading, error, refetch } = useGetAssignedEvaluationTask(enabled);
  const task = useMemo<EvaluationTask | null>(() => data || null, [data]);

  const questions = useMemo<Question[]>(() => task?.questions || [], [task]);

  const hasTask = task !== null;
  const hasQuestions = questions.length > 0;

  return {
    task,
    questions,
    taskId: task?.id,
    isChallenge: task?.is_challenge ?? false,
    isLoading,
    error,
    hasTask,
    hasQuestions,
    refetch,
  };
}

/**
 * Hook to assign and get evaluation task for a specific group
 */
export function useAssignEvaluationTask(
  evaluationGroupId?: string,
  enabled: boolean = true
) {
  const { data, isLoading, error, refetch } = useAssignAndGetEvaluationTask(
    evaluationGroupId,
    enabled
  );

  const task = useMemo<EvaluationTask | null>(() => data || null, [data]);

  const questions = useMemo<Question[]>(() => task?.questions || [], [task]);

  const hasTask = task !== null;
  const hasQuestions = questions.length > 0;

  return {
    task,
    questions,
    taskId: task?.id,
    isChallenge: task?.is_challenge ?? false,
    isLoading,
    error,
    hasTask,
    hasQuestions,
    refetch,
  };
}
